<template>
  <div class="home">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="logo">
          <img src="@/assets/logo.png" alt="趣馋兔品牌Logo - 手撕烤兔、麻辣兔头专业品牌" class="logo-img">
          <h1>趣馋兔</h1>
        </div>
        <ul class="nav-menu">
          <li><a href="#home" @click.prevent="scrollToSection('home')">首页</a></li>
          <li><a href="#products" @click.prevent="scrollToSection('products')">产品中心</a></li>
          <li><a href="#about" @click.prevent="scrollToSection('about')">关于我们</a></li>
          <li><a href="#news" @click.prevent="scrollToSection('news')">新闻资讯</a></li>
          <li><a href="#contact" @click.prevent="scrollToSection('contact')">联系我们</a></li>
        </ul>
      </div>
    </nav>

    <!-- Banner 轮播图 -->
    <section class="banner" id="home">
      <div class="banner-container" v-if="bannerList.length > 0">
        <div class="banner-wrapper" :style="bannerWrapperStyle">
          <div
            v-for="(item, index) in bannerList"
            :key="index"
            class="banner-item"
          >
            <img :src="item.picImge" :alt="item.picName || '趣馋兔品牌宣传图'">
          </div>
          <!-- 复制第一张图实现无缝循环 -->
          <div class="banner-item">
            <img :src="bannerList[0].picImge" :alt="bannerList[0].picName || '趣馋兔品牌宣传图'">
          </div>
        </div>

        <!-- 切换按钮 -->
        <button class="banner-btn prev" @click="prevBanner">‹</button>
        <button class="banner-btn next" @click="nextBanner">›</button>

        <!-- 指示器 -->
        <div class="banner-indicators">
          <span
            v-for="(item, index) in bannerList"
            :key="index"
            :class="{ active: currentBannerIndex === index }"
            @click="goToBanner(index)"
          ></span>
        </div>
      </div>
      <!-- 加载状态 -->
      <div class="banner-loading" v-else>
        <p>加载中...</p>
      </div>
    </section>
    <!-- 产品中心 -->
    <section class="products" id="products">
      <div class="container">
        <h2 class="section-title">产品中心</h2>
        <p class="section-subtitle">PRODUCT CENTER</p>
        <div class="product-grid">
          <div class="product-card" v-for="(product, index) in productList" :key="index">
            <div class="product-image">
              <img :src="product.picImge " :alt="product.picName || '趣馋兔特色产品'">
            </div>
            <div class="product-info">
              <h3>{{ product.picName }}</h3>
              <p>{{ product.remark }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="about" id="about">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">ABOUT US</p>
        <div class="about-content-new">
          <div class="brand-intro">
            <div class="brand-header">
              <h3>趣馋兔：解锁味蕾记忆，重构烟火温情</h3>
              <p class="brand-slogan">品牌理念：趣寻美味，馋牵记忆</p>
            </div>

            <div class="brand-grid">
              <div class="brand-card">
                <div class="card-icon">🎯</div>
                <h4>品牌释义</h4>
                <p>"趣" 是探索美味的初心，是对每一口滋味的不懈追求。就像孩童在巷弄里探寻神秘宝藏，趣馋兔带着好奇与热情，穿梭于各地的烟火街巷，寻找那些藏在民间的独特风味。"馋" 是勾连记忆的纽带，是妈妈卤味的温暖，是街角老店的烟火气，是无论走到哪里都难以忘怀的家乡味道。</p>
                <p class="highlight">巷陌深处，烟火袅袅，那不是野味却胜似野味的独特风味，正是趣馋兔手撕烤兔。</p>
              </div>

              <div class="brand-card">
                <div class="card-icon">🚀</div>
                <h4>创立背景与发展</h4>
                <p>2022 年，趣馋兔品牌在中国诞生，怀揣着年轻化、健康化、趣味性的核心定位，瞄准快速增长的卤味熟食市场，开启了逐梦之旅。</p>
                <p>2023 年 11 月，品牌完成商标注册，从初创品牌向规范化企业华丽转型，以更成熟、更专业的姿态在休闲食品市场崭露头角。</p>
              </div>
            </div>

            <div class="core-values-section">
              <h4 class="values-title">品牌核心价值</h4>
              <div class="values-grid">
                <div class="value-item">
                  <div class="value-number">01</div>
                  <h5>手作温度</h5>
                  <p class="value-desc">拒绝工业化，匠心铸美味</p>
                  <p>精选绿色生态兔，8 小时精心腌制，2 小时文火慢卤，20 分钟文火慢烤，最后五分钟人工撕制，让每一丝兔肉都带着匠人的用心。</p>
                </div>
                <div class="value-item">
                  <div class="value-number">02</div>
                  <h5>记忆重构</h5>
                  <p class="value-desc">现代技术焕新传统，风味突破地域</p>
                  <p>用现代技术优化传统配方，让藏在深巷的美味突破地域限制，用熟悉的味道唤醒心灵深处的温暖。</p>
                </div>
                <div class="value-item">
                  <div class="value-number">03</div>
                  <h5>烟火疗愈</h5>
                  <p class="value-desc">都市里的温情港湾，人与食物的情感联结</p>
                  <p>重建人与食物的情感联结，撕一口烟火，解三千烦忧，每一口手撕烤兔，都是对忙碌生活的温柔慰藉。</p>
                </div>
              </div>
            </div>

            <div class="recipe-section">
              <h4 class="recipe-title">配方：健康与美味的完美融合</h4>
              <div class="recipe-cards">
                <div class="recipe-card">
                  <div class="recipe-icon">🥩</div>
                  <h5>主料</h5>
                  <p class="recipe-subtitle">养生兔肉，吃肉不长肉</p>
                  <p>兔肉素有 "保健肉""美容肉""长寿肉" 等美称，易消化、低脂肪、低胆固醇，让你尽情享受美味不用担心身材走样。</p>
                </div>
                <div class="recipe-card">
                  <div class="recipe-icon">🌿</div>
                  <h5>调料</h5>
                  <p class="recipe-subtitle">香料增味，养生相伴</p>
                  <p>冰糖炒色，草果健胃消食，八角健胃祛寒，丁香治疗胃部不适，各种香料不仅增味更带来养生功效。</p>
                </div>
                <div class="recipe-card">
                  <div class="recipe-icon">✨</div>
                  <h5>工艺</h5>
                  <p class="recipe-subtitle">三道工艺，健康承诺</p>
                  <p>先腌制后卤再烤，采用纯香料以及加碘盐和糖，未使用任何添加剂、色素和防腐剂，真空包装冷藏可达半年。</p>
                </div>
              </div>
            </div>

            <div class="brand-conclusion">
              <p>趣馋兔，不仅仅是一个休闲食品品牌，更是一种生活态度的传递。它用美味唤醒记忆，用匠心传递温度，在都市的喧嚣中，为人们打造一个充满烟火气的温情港湾。无论你是在家享受闲暇时光，还是与朋友相聚狂欢，亦或是踏上旅途寻找诗和远方，趣馋兔都将是你的绝佳选择。</p>
              <p class="conclusion-highlight">快来品尝趣馋兔手撕烤兔，让那一抹独特的风味，成为你记忆中挥之不去的美好。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻资讯 -->
    <section class="news" id="news">
      <div class="container">
        <h2 class="section-title">新闻资讯</h2>
        <p class="section-subtitle">NEWS & EVENTS</p>
        <div class="news-grid">
          <div class="news-card" v-for="(newsItem, index) in newsList" :key="index">
            <h3 class="news-title">{{ newsItem.newsName }}</h3>
            <div class="news-content-rich" v-html="truncateContent(newsItem.newsContent)" @click="goToNewsDetail(newsItem.id)"></div>
            <button type="button" @click.stop="goToNewsDetail(newsItem.id)" class="read-more-btn">资讯详情 →</button>
            <div class="news-footer">
              <span class="news-date">{{ formatDate(newsItem.createTime) }}</span>
              <span class="news-creator">作者：{{ newsItem.creator }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact" id="contact">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">CONTACT US</p>
        <div class="contact-content">
          <div class="contact-left">
            <div class="contact-info">
              <div class="contact-item">
                <span class="label">电话：</span>
                <span class="value">185 1607 9685</span>
              </div>
              <div class="contact-item">
                <span class="label">邮箱：</span>
                <span class="value">153230246@qq.com</span>
              </div>
              <div class="contact-item">
                <span class="label">微信：</span>
                <span class="value">zhaoxiang200</span>
              </div>
            </div>
            <div class="wechat-qrcode">
              <img src="@/assets/weixin.png" alt="趣馋兔官方微信二维码 - 扫码添加微信咨询加盟详情">

            </div>
          </div>
          <div class="contact-right">
            <div class="map-container">
              <iframe
                src="https://m.amap.com/navi/?dest=120.635,31.375&destName=趣馋兔欢迎您&key=91ba4a8289a7cc5c7a7ab19486e889e2"
                frameborder="0"
                scrolling="no"
                marginwidth="0"
                marginheight="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>&copy; 2024 午申企业管理公司工作室 版权所有</p>
        <p>ICP 备案号：豫ICP备2025119208号 </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { getNewsList } from '../api/news'
import { getBannerList } from '../api/banner'
import { getProductList } from '../api/product'
export default {
  name: 'HomePage',
  data() {
    return {
      currentBannerIndex: 0,
      autoPlayTimer: null,
      isTransitioning: false,
      bannerList: [],
      productList: [],
      newsList: []
    }
  },
  computed: {
    bannerWrapperStyle() {
      const translateX = -this.currentBannerIndex * 100
      return {
        transform: `translateX(${translateX}%)`,
        transition: this.isTransitioning ? 'transform 0.5s ease-in-out' : 'none'
      }
    }
  },
  mounted() {
    // 设置页面 SEO 信息
    this.setSEOInfo()

    // 加载产品列表
    this.loadProductList()
    // 加载新闻列表（最新 3 条）
    this.loadNewsList()
    // 加载 Banner 列表（内部会启动自动轮播）
    this.loadBannerList()
  },
  beforeUnmount() {
    // 清除定时器
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer)
    }
  },
  methods: {
    // 设置 SEO 信息
    setSEOInfo() {
      // 设置页面标题
      document.title = '趣馋兔'

      // 设置 meta description
      let metaDescription = document.querySelector('meta[name="description"]')
      if (!metaDescription) {
        metaDescription = document.createElement('meta')
        metaDescription.name = 'description'
        document.head.appendChild(metaDescription)
      }
      metaDescription.content = '手撕、烤兔、麻辣兔头、五香兔腿品牌，采用传统工艺制作，8小时腌制、2小时文火慢卤、20分钟文火慢烤，无添加剂，健康美味。全国加盟热线：185 1607 9685'

      // 设置 meta keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]')
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta')
        metaKeywords.name = 'keywords'
        document.head.appendChild(metaKeywords)
      }
      metaKeywords.content = '趣馋兔,手撕烤兔,麻辣兔头,五香兔腿,炭火烤兔,休闲食品,卤味熟食,传统工艺,健康美食,加盟连锁'

      // 设置 Open Graph 标签（用于社交媒体分享）
      this.setMetaProperty('og:title', '趣馋兔官网 - 手撕烤兔、麻辣兔头专业品牌')
      this.setMetaProperty('og:description', '传统工艺制作的手撕烤兔、麻辣兔头，无添加剂，健康美味')
      this.setMetaProperty('og:type', 'website')
      this.setMetaProperty('og:url', window.location.href)
      this.setMetaProperty('og:image', 'https://quchantu.cn/upload/logo.png')

      // 设置 viewport
      let viewport = document.querySelector('meta[name="viewport"]')
      if (viewport) {
        viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=5.0'
      }
    },

    // 设置 Open Graph meta 标签
    setMetaProperty(property, content) {
      let meta = document.querySelector(`meta[property="${property}"]`)
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('property', property)
        document.head.appendChild(meta)
      }
      meta.content = content
    },

    // 加载 Banner 列表
    async loadBannerList() {
      try {
        const result = await getBannerList()
        console.log('Banner - API 返回数据:', result)

        // request.js 响应拦截器已经返回了 res.data
        let bannerData = result

        // 如果返回的是对象且包含 data 字段
        if (result && typeof result === 'object' && !Array.isArray(result)) {
          bannerData = result.data || result.list || result.banners || []
        }

        if (Array.isArray(bannerData)) {
          this.bannerList = bannerData
          console.log('Banner - 轮播图数据:', this.bannerList)

          // 数据加载完成后启动自动轮播
          this.$nextTick(() => {
            this.startAutoPlay()
          })
        } else {
          console.warn('API 返回的不是数组:', bannerData)
          this.bannerList = []
        }
      } catch (error) {
        console.error('加载 Banner 列表失败:', error)
        // 如果 API 失败，使用默认数据
        this.bannerList = [
          {
            id: 1,
            picImge: 'https://quchantu.cn/upload/banner-1.png',
            picName: 'Banner 1',
            link: ''
          },
          {
            id: 2,
            picImge: 'https://quchantu.cn/upload/banner-2.png',
            picName: 'Banner 2',
            link: ''
          }
        ]

        // 使用默认数据后也要启动轮播
        this.$nextTick(() => {
          this.startAutoPlay()
        })
      }
    },

    // 加载产品列表
    async loadProductList() {
      try {
        const result = await getProductList()
        console.log('Product - API 返回数据:', result)

        // request.js 响应拦截器已经返回了 res.data
        let productData = result

        // 如果返回的是对象且包含 data 字段
        if (result && typeof result === 'object' && !Array.isArray(result)) {
          productData = result.data || result.list || result.products || []
        }

        if (Array.isArray(productData)) {
          this.productList = productData
          console.log('Product - 产品列表数据:', this.productList)
        } else {
          console.warn('API 返回的不是数组:', productData)
          // 如果 API 失败，使用默认数据
          this.productList = [
            {
              id: 1,
              imageUrl: 'https://quchantu.cn/upload/malatutui-shu.jpg',
              name: '手撕烤兔',
              description: '传统工艺制作，外酥里嫩，香气四溢'
            },
            {
              id: 2,
              imageUrl: 'https://quchantu.cn/upload/malatutou-002.jpg',
              name: '麻辣兔头',
              description: '香辣入味，回味无穷'
            },
            {
              id: 3,
              imageUrl: 'https://quchantu.cn/upload/tutou-shu.jpg',
              name: '五香兔头',
              description: '五香浓郁，肉质鲜美'
            },
            {
              id: 4,
              imageUrl: 'https://quchantu.cn/upload/tuza-001.jpg',
              name: '麻辣兔腿',
              description: '肉质紧实，麻辣鲜香'
            },
            {
              id: 5,
              imageUrl: 'https://quchantu.cn/upload/tanhuokaotu-shu.jpg',
              name: '炭火烤兔',
              description: '炭火慢烤，皮脆肉嫩'
            },
            {
              id: 6,
              imageUrl: 'https://quchantu.cn/upload/malatutui-heng.jpg',
              name: '五香兔腿',
              description: '五香醇厚，营养健康'
            }
          ]
        }
      } catch (error) {
        console.error('加载产品列表失败:', error)
        // 如果 API 失败，使用默认数据
        this.productList = [
          {
            id: 1,
            imageUrl: 'https://quchantu.cn/upload/malatutui-shu.jpg',
            name: '手撕烤兔',
            description: '传统工艺制作，外酥里嫩，香气四溢'
          },
          {
            id: 2,
            imageUrl: 'https://quchantu.cn/upload/malatutou-002.jpg',
            name: '麻辣兔头',
            description: '香辣入味，回味无穷'
          },
          {
            id: 3,
            imageUrl: 'https://quchantu.cn/upload/tutou-shu.jpg',
            name: '五香兔头',
            description: '五香浓郁，肉质鲜美'
          },
          {
            id: 4,
            imageUrl: 'https://quchantu.cn/upload/tuza-001.jpg',
            name: '麻辣兔腿',
            description: '肉质紧实，麻辣鲜香'
          },
          {
            id: 5,
            imageUrl: 'https://quchantu.cn/upload/tanhuokaotu-shu.jpg',
            name: '炭火烤兔',
            description: '炭火慢烤，皮脆肉嫩'
          },
          {
            id: 6,
            imageUrl: 'https://quchantu.cn/upload/malatutui-heng.jpg',
            name: '五香兔腿',
            description: '五香醇厚，营养健康'
          }
        ]
      }
    },

    // 加载新闻列表（首页 - 最新 3 条）
    async loadNewsList() {
      try {
        const result = await getNewsList()
        console.log('HomePage - API 返回数据:', result)

        // request.js 响应拦截器已经返回了 res.data
        if (Array.isArray(result)) {
          // 只取前 3 条
          this.newsList = result.slice(0, 3)
          console.log('HomePage - 新闻列表数据:', this.newsList)
        } else {
          console.warn('API 返回的不是数组:', result)
          this.newsList = []
        }
        console.log('HomePage - 最终 newsList:', this.newsList)
        console.log('HomePage - newsList 长度:', this.newsList.length)
      } catch (error) {
        console.error('加载新闻列表失败:', error)
        this.newsList = []
      }
    },

    // 下一张
    nextBanner() {
      if (this.isTransitioning) return

      this.isTransitioning = true
      this.currentBannerIndex++

      // 如果到了复制的第一张图，立即切回真正的第二张图
      setTimeout(() => {
        if (this.currentBannerIndex >= this.bannerList.length) {
          this.currentBannerIndex = 0
          this.isTransitioning = false
        } else {
          this.isTransitioning = false
        }
      }, 500)
    },

    // 上一张
    prevBanner() {
      if (this.isTransitioning) return

      this.isTransitioning = true

      if (this.currentBannerIndex === 0) {
        // 从第一张往前，先瞬间跳到最后一张
        this.currentBannerIndex = this.bannerList.length
        // 然后立即开始动画
        this.$nextTick(() => {
          setTimeout(() => {
            this.currentBannerIndex--
            setTimeout(() => {
              this.isTransitioning = false
            }, 500)
          }, 50)
        })
      } else {
        this.currentBannerIndex--
        setTimeout(() => {
          this.isTransitioning = false
        }, 500)
      }
    },

    // 跳转到指定索引
    goToBanner(index) {
      if (this.isTransitioning) return

      this.isTransitioning = true
      this.currentBannerIndex = index
      this.resetAutoPlay()

      setTimeout(() => {
        this.isTransitioning = false
      }, 500)
    },

    // 启动自动轮播
    startAutoPlay() {
      if (this.bannerList.length === 0) return

      // 先清除已有的定时器
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
      }

      this.autoPlayTimer = setInterval(() => {
        this.nextBanner()
      }, 3000) // 3 秒切换一次
    },

    // 重置自动轮播
    resetAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer)
      }
      this.startAutoPlay()
    },

    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 跳转到新闻详情页
    goToNewsDetail(newsId) {
      if (!newsId) {
        console.error('新闻 ID 为空')
        return
      }
      if (!this.$router) {
        // 尝试直接修改 URL hash
        window.location.hash = '#/news?id=' + newsId
        return
      }
      // 使用 push 方式跳转
      this.$router.push({
        name: 'NewsCenter',
        query: {
          id: newsId
        }
      }).then(() => {
        console.log('路由跳转成功')
      }).catch(err => {
        console.error('路由跳转失败:', err)
      })
    },

    // 截断内容
    truncateContent(content, maxLength = 100) {
      if (!content) return ''
      if (content.length <= maxLength) return content
      return content.slice(0, maxLength) + '...'
    },

    // 滚动到指定区域
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        const navHeight = 70 // 导航栏高度
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        window.scrollTo({
          top: elementPosition - navHeight,
          behavior: 'smooth'
        })
      }
    }
  }
}

</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.home {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏 */
.navbar {
  background: linear-gradient(135deg, #d32f2f 0%, #e53935 100%);
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  height: 50px;
  width: auto;
  object-fit: contain;
  border-radius: 12px; /* 圆角矩形 */
  background: #fff;
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.logo h1 {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  margin: 0;
  line-height: 1;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 40px;
}

.nav-menu a {
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s;
  font-weight: 500;
}

.nav-menu a:hover {
  color: #ffebee;
  transform: translateY(-2px);
}

/* Banner */
.banner {
  margin-top: 70px;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.banner-container {
  position: relative;
  width: 100%;
  height: 510px;
  overflow: hidden;
}

.banner-wrapper {
  display: flex;
  height: 100%;
  will-change: transform;
}

.banner-item {
  min-width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.banner-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: none;
  color: #fff;
  font-size: 50px;
  padding: 15px 20px;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s;
  border-radius: 5px;
  user-select: none;
}

.banner-btn:hover {
  background: rgba(211, 47, 47, 0.8);
}

.banner-btn.prev {
  left: 20px;
}

.banner-btn.next {
  right: 20px;
}

.banner-indicators {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.banner-indicators span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.banner-indicators span.active {
  background: #d32f2f;
  width: 30px;
  border-radius: 6px;
  border-color: #fff;
}

.banner-indicators span:hover {
  background: rgba(211, 47, 47, 0.8);
}

/* Banner 加载状态 */
.banner-loading {
  width: 100%;
  height: 510px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
  font-size: 18px;
}

/* 通用样式 */
.section-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.section-subtitle {
  text-align: center;
  color: #999;
  font-size: 14px;
  letter-spacing: 2px;
  margin-bottom: 50px;
}

/* 产品中心 */
.products {
  padding: 80px 0;
  background: linear-gradient(180deg, #f9f9f9 0%, #fff 100%);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.product-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 25px rgba(211, 47, 47, 0.2);
}

.product-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.product-image img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.product-info {
  padding: 25px 20px;
  text-align: center;
  background: linear-gradient(135deg, #d32f2f 0%, #e53935 100%);
  color: #fff;
}

.product-info h3 {
  font-size: 18px;
  color: #fff;
  margin-bottom: 10px;
  font-weight: bold;
}

.product-info p {
  color: #ffebee;
  font-size: 14px;
  line-height: 1.6;
}

/* 关于我们 */
.about {
  padding: 100px 0;
  background: linear-gradient(180deg, #f9f9f9 0%, #fff 100%);
}

.about-content-new {
  max-width: 1000px;
  margin: 0 auto;
}

.brand-header {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 3px solid #ffcdd2;
}

.brand-header h3 {
  font-size: 36px;
  color: #d32f2f;
  margin-bottom: 15px;
  font-weight: bold;
}

.brand-slogan {
  font-size: 20px;
  color: #e53935;
  font-weight: 500;
  letter-spacing: 1px;
}

.brand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.brand-card {
  background: #fff;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: all 0.3s;
  border: 1px solid #f0f0f0;
}

.brand-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(211, 47, 47, 0.15);
}

.card-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.brand-card h4 {
  font-size: 24px;
  color: #d32f2f;
  margin-bottom: 20px;
  font-weight: bold;
}

.brand-card p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
}

.brand-card .highlight {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #d32f2f;
  font-weight: 500;
  color: #333;
}

.core-values-section {
  margin-bottom: 60px;
}

.values-title {
  font-size: 28px;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
  font-weight: bold;
  position: relative;
}

.values-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #d32f2f;
  margin: 15px auto 0;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.value-item {
  background: linear-gradient(135deg, #fff 0%, #ffebee 100%);
  padding: 35px;
  border-radius: 15px;
  border: 2px solid #ffcdd2;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.value-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #d32f2f 0%, #e53935 100%);
}

.value-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(211, 47, 47, 0.15);
}

.value-number {
  font-size: 48px;
  font-weight: bold;
  color: rgba(211, 47, 47, 0.1);
  position: absolute;
  top: 10px;
  right: 20px;
  font-family: 'Arial', sans-serif;
}

.value-item h5 {
  font-size: 22px;
  color: #d32f2f;
  margin-bottom: 10px;
  font-weight: bold;
}

.value-desc {
  font-size: 15px;
  color: #e53935;
  font-weight: 500;
  margin-bottom: 15px;
  font-style: italic;
}

.value-item p:last-child {
  color: #666;
  line-height: 1.8;
  margin-bottom: 0;
}

.recipe-section {
  margin-bottom: 60px;
}

.recipe-title {
  font-size: 28px;
  color: #333;
  text-align: center;
  margin-bottom: 40px;
  font-weight: bold;
  position: relative;
}

.recipe-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #d32f2f;
  margin: 15px auto 0;
}

.recipe-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.recipe-card {
  background: #fff;
  padding: 35px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #f0f0f0;
}

.recipe-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(255, 107, 0, 0.15);
}

.recipe-icon {
  font-size: 50px;
  margin-bottom: 15px;
}

.recipe-card h5 {
  font-size: 22px;
  color: #d32f2f;
  margin-bottom: 10px;
  font-weight: bold;
}

.recipe-subtitle {
  font-size: 16px;
  color: #e53935;
  font-weight: 500;
  margin-bottom: 15px;
}

.recipe-card p {
  color: #666;
  line-height: 1.8;
  font-size: 14px;
}

.brand-conclusion {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  padding: 50px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(211, 47, 47, 0.1);
  text-align: center;
  border: 2px solid #ffcdd2;
}

.brand-conclusion p {
  font-size: 18px;
  line-height: 2;
  color: #333;
  margin-bottom: 20px;
}

.conclusion-highlight {
  font-size: 20px !important;
  font-weight: bold !important;
  color: #d32f2f !important;
  margin-top: 25px !important;
  padding-top: 25px !important;
  border-top: 2px solid rgba(211, 47, 47, 0.3) !important;
}

/* 新闻资讯 */
.news {
  padding: 80px 0;
  background: #f9f9f9;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.news-card {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(211, 47, 47, 0.15);
}

.news-title {
  font-size: 20px;
  color: #d32f2f;
  margin-bottom: 15px;
  font-weight: bold;
  line-height: 1.4;
}

.news-content-rich {
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 14px;
  cursor: pointer;
  flex: 1;

  /* 限制显示 3-5 行 */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  /* 保持一定的行高 */
  max-height: 126px;
}

.news-content-rich:hover {
  color: #d32f2f;
}

.read-more-btn {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 14px;
  transition: color 0.3s;
  display: inline-block;
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 4px;
}

.read-more-btn:hover {
  color: #e53935;
  background-color: rgba(211, 47, 47, 0.1);
}

.news-footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.news-date {
  color: #d32f2f;
  font-size: 13px;
  font-weight: 500;
}

.news-creator {
  color: #d32f2f;
  font-size: 13px;
  font-style: italic;
}

/* 联系我们 */
.contact {
  padding: 80px 0;
}

.contact-content {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 40px;
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
}

.contact-left {
  padding: 40px;
  background: linear-gradient(135deg, #d32f2f 0%, #d32f2f 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 40px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 16px;
}

.contact-item .label {
  color: #f8f5f5;
  font-weight: bold;
  min-width: 80px;
}

.contact-item .value {
  color: #f8f5f5;
  font-weight: 500;
}

.wechat-qrcode {
  text-align: center;
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.1);
}

.wechat-qrcode img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
  margin: 0 auto 15px;
}

.qrcode-tip {
  color: #d32f2f;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.contact-right {
  position: relative;
  min-height: 450px;
}

.map-container {
  width: 100%;
  height: 100%;
  min-height: 450px;
}

.map-container iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 页脚 */
.footer {
  background: #333;
  color: #fff;
  padding: 30px 0;
  text-align: center;
}

.footer p {
  margin-bottom: 10px;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-menu {
    gap: 20px;
  }

  .nav-menu a {
    font-size: 14px;
  }

  .logo-img {
    height: 40px;
  }

  .logo h1 {
    font-size: 22px;
  }

  .banner-container {
    height: 255px;
  }

  .banner-loading {
    height: 255px;
  }

  .banner-btn {
    font-size: 30px;
    padding: 10px 15px;
  }

  .banner-btn.prev {
    left: 10px;
  }

  .banner-btn.next {
    right: 10px;
  }

  .banner-indicators {
    bottom: 15px;
  }

  .banner-indicators span {
    width: 10px;
    height: 10px;
  }

  .banner-indicators span.active {
    width: 20px;
  }

  .about-content {
    grid-template-columns: 1fr;
  }

  .about-text h3 {
    font-size: 24px;
  }

  .brand-slogan {
    font-size: 16px;
  }

  .about-section h4 {
    font-size: 18px;
  }

  .core-value {
    padding: 15px;
  }

  .about-image img {
    position: static;
    margin-top: 30px;
  }

  .product-grid,
  .news-grid {
    grid-template-columns: 1fr;
  }

  .contact-content {
    grid-template-columns: 1fr;
  }

  .contact-left {
    padding: 30px 20px;
  }

  .contact-right {
    min-height: 300px;
  }

  .map-container {
    min-height: 300px;
  }

  .wechat-qrcode img {
    width: 150px;
    height: 150px;
  }
}
</style>
